














































import {
  defineComponent,
  ref,
  onMounted,
  PropType,
  computed,
  inject,
} from '@vue/composition-api';
import Stoplight from './Stoplight.vue';
import { TranslitOption } from '@oare/types';
import sl from '@/serviceLocator';
import { EpigraphyReloadKey } from '../../index.vue';

export default defineComponent({
  components: {
    Stoplight,
  },
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    transliteration: {
      type: Object as PropType<TranslitOption>,
      required: true,
    },
    textUuid: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const translitOptions = ref<TranslitOption[]>([]);
    const server = sl.get('serverProxy');
    const actions = sl.get('globalActions');
    const selectedColor = ref(props.transliteration.color);
    const reload = inject(EpigraphyReloadKey);

    onMounted(async () => {
      translitOptions.value = await server.getTranslitOptions();
    });

    const translitDictionary = computed(() => {
      const map = new Map();
      translitOptions.value.map(option =>
        map.set(option.color, option.colorMeaning)
      );
      return map;
    });

    const selectedStatus = computed(() => ({
      color: selectedColor.value,
      colorMeaning: translitDictionary.value.get(selectedColor.value),
    }));

    const updateTranslitStatus = async () => {
      try {
        await server.updateTranslitStatus(props.textUuid, selectedColor.value);
        actions.showSnackbar('Successfully updated transliteration status.');
        reload && reload();
      } catch(err) {
        actions.showErrorSnackbar(
          'Error updating transliteration status. Please try again.',
          err as Error
        );
      }
    };

    return {
      translitOptions,
      selectedColor,
      selectedStatus,
      updateTranslitStatus,
    };
  },
});
